import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import SignUp from '../pages/SignUp';
import DukaList from '../pages/DukaList/index';
import ProductList from '../pages/ProductList/index';
import StockManagement from '../pages/StockManagement';
// import Orders from '../pages/Orders';
import OrderList from '../pages/OrderList/index'
import ServiceLevels from '../pages/ServiceLevel/index';
import Projections from '../pages/Projections/index';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import ProtectedRoute from '../components/auth/ProtectedRoute'
import AdjustmentLevels from '../pages/AdjustmentLevel/index';
import Amendments from '../pages/Amendments';
import UserManagement from '../pages/UserManagement';
import DukaStockManagement from '../pages/DukaStockManagement';
import ErrorPage from '../components/ErrorPage';
import RoleProtectedRoute from './RoleProtectedRoute'
import { AuthContext } from '../contexts/AuthContext';
import SalesList from '../pages/SalesList/index';

const AppRoutes = () => {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/api/auth/reset-password/:userId/:token" element={<ResetPassword />} />

      {/* Protected Routes (Requires login) */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* 
          Index route:
          For coordinator roles, redirect to '/dukas' (their home). 
          Otherwise, show the dashboard.
        */}
        <Route
          index
          element={
            (user?.role?.name === 'AREA_COORDINATOR' ||
              user?.role?.name === 'LOGISTICS_COORDINATOR') ? (
              <Navigate to="/dukas" replace />
            ) : (
              <Dashboard />
            )
          }
        />

        {/* Duka: Accessible by all roles */}
        <Route
          path="dukas"
          element={
            <RoleProtectedRoute
              allowedRoles={[
                'ADMIN',
                'DATA_MANAGER',
                'AREA_COORDINATOR',
                'LOGISTICS_COORDINATOR',
              ]}
            >
              <DukaList />
            </RoleProtectedRoute>
          }
        />

        {/* Products: Only ADMIN and DATA_MANAGER */}
        <Route
          path="products"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <ProductList />
            </RoleProtectedRoute>
          }
        />

        {/* Stock: Accessible by ADMIN, DATA_MANAGER, and LOGISTICS_COORDINATOR */}
        <Route
          path="stock"
          element={
            <RoleProtectedRoute
              allowedRoles={['ADMIN', 'DATA_MANAGER', 'LOGISTICS_COORDINATOR']}
            >
              <StockManagement />
            </RoleProtectedRoute>
          }
        />

        {/* Orders: Accessible by ADMIN, DATA_MANAGER, and AREA_COORDINATOR */}
        <Route
          path="orders"
          element={
            <RoleProtectedRoute
              allowedRoles={['ADMIN', 'DATA_MANAGER', 'AREA_COORDINATOR']}
            >
              <OrderList />
            </RoleProtectedRoute>
          }
        />

        {/* Sales: Accessible by ADMIN, DATA_MANAGER, and AREA_COORDINATOR */}
        <Route
          path="sales"
          element={
            <RoleProtectedRoute
              allowedRoles={['ADMIN', 'DATA_MANAGER', 'AREA_COORDINATOR']}
            >
              <SalesList />
            </RoleProtectedRoute>
          }
        />

        {/* Service Levels: Only ADMIN and DATA_MANAGER */}
        <Route
          path="service-levels"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <ServiceLevels />
            </RoleProtectedRoute>
          }
        />

        {/* Adjustment Levels: Only ADMIN and DATA_MANAGER */}
        <Route
          path="adjustment-levels"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <AdjustmentLevels />
            </RoleProtectedRoute>
          }
        />

        {/* Projections: Only ADMIN and DATA_MANAGER */}
        <Route
          path="projections"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <Projections />
            </RoleProtectedRoute>
          }
        />

        {/* Amendments: Accessible by ADMIN, DATA_MANAGER, and AREA_COORDINATOR */}
        <Route
          path="amendments"
          element={
            <RoleProtectedRoute
              allowedRoles={['ADMIN', 'DATA_MANAGER', 'AREA_COORDINATOR']}
            >
              <Amendments />
            </RoleProtectedRoute>
          }
        />

        {/* User Management: Only ADMIN and DATA_MANAGER */}
        <Route
          path="user-management"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <UserManagement />
            </RoleProtectedRoute>
          }
        />

        {/* Duka Stock: Only ADMIN and DATA_MANAGER */}
        <Route
          path="duka-stock"
          element={
            <RoleProtectedRoute allowedRoles={['ADMIN', 'DATA_MANAGER']}>
              <DukaStockManagement />
            </RoleProtectedRoute>
          }
        />
      </Route>

      {/* Custom Error Routes */}
      <Route
        path="/403"
        element={
          <ErrorPage
            code={403}
            message="Forbidden: You do not have permission to access this page."
          />
        }
      />
      <Route
        path="*"
        element={
          <ErrorPage
            code={404}
            message="Page Not Found: The page you are looking for does not exist."
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;